// Product description sections: closed accordions on phones, always open from 750px up.
// The markup ships with every section open, so content is readable without JavaScript;
// this element closes them on small screens and keeps them open on larger ones.
if (!customElements.get('solvex-description')) {
  customElements.define(
    'solvex-description',
    class SolvexDescription extends HTMLElement {
      connectedCallback() {
        this.query = window.matchMedia('(min-width: 750px)');
        this.sync = () => {
          this.querySelectorAll('details').forEach((details) => {
            details.open = this.query.matches;
          });
        };
        // 'toggle' does not bubble, so listen in the capture phase.
        this.keepOpen = (event) => {
          if (this.query.matches && event.target.tagName === 'DETAILS' && !event.target.open) {
            event.target.open = true;
          }
        };
        this.sync();
        this.query.addEventListener('change', this.sync);
        this.addEventListener('toggle', this.keepOpen, true);
      }

      disconnectedCallback() {
        this.query.removeEventListener('change', this.sync);
        this.removeEventListener('toggle', this.keepOpen, true);
      }
    }
  );
}
